import { useState, useEffect ,useRef} from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa";
import icons from "../../../icons.config";
import { fetchOrderDetailsByIdAPI } from "../../../Providers/ordersProvider";
import { getUserProfileAPI } from "../../../Providers/profileProvider";

const TrackOrderPopup = ({ onClose ,setShowErrorPopup}) => {
  const { orderId: paramOrderId } = useParams();
  const [orderId, setOrderId] = useState(paramOrderId || "");
  const [orderStatus, setOrderStatus] = useState(null);
  const [order, setOrder] = useState(null);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  const authToken = useSelector((state) => state.auth.authToken);
  const user_id = useSelector((state) => state.auth.user?.id) || localStorage.getItem("user_id");

  const handleSubmit = async () => {
    try {
      localStorage.setItem("authToken", authToken);
      localStorage.setItem("user_id", user_id);
  
      console.log("Submitting orderId:", orderId);
      const sanitizedOrderId = orderId.trim().toUpperCase();
      const response = await fetchOrderDetailsByIdAPI(sanitizedOrderId, authToken, user_id);
  
      if (response && response.success && response.items.length > 0) {
        console.log("Order found:", response.items[0]);
        setOrder(response.items[0]);
        setOrderStatus(response.items[0].status);
      } else {
        console.log("No order found with ID:", sanitizedOrderId);
        setOrderStatus(null);
        onClose(); // Close the TrackOrderPopup
        setTimeout(() => setShowErrorPopup(true), 300); // Delay ErrorPopup display for smooth transition
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      setOrderStatus(null);
      onClose(); // Close the TrackOrderPopup
      setTimeout(() => setShowErrorPopup(true), 300); // Delay ErrorPopup display for smooth transition
    }
  };
  
  

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await getUserProfileAPI();
        if (response?.data) {
          setUser(response.data);
        } else {
          setError(response.error || "Unexpected response format");
          console.error("Error fetching user profile:", response);
        }
      } catch (error) {
        setError("Failed to fetch user profile");
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  // Define order steps and calculate progress height
  const orderSteps = ["PLACED", "SHIPPED", "DELIVERED"];
  const currentStepIndex = orderSteps.indexOf(orderStatus);
  const progressHeight = currentStepIndex === -1 ? "0%" : `${(currentStepIndex / (orderSteps.length - 1)) * 100}%`;

  useEffect(() => {
      document.body.classList.add("overflow-hidden");
      return () => {
        document.body.classList.remove("overflow-hidden");
      };
    }, []);
     const popupRef = useRef(null);
    
      useEffect(() => {
        // Function to handle click outside
        const handleClickOutside = (event) => {
          if (popupRef.current && !popupRef.current.contains(event.target)) {
           onClose();
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [onClose]);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-30 top-16 md:top-0 lg:top-24 backdrop-blur-sm ">
      <div className="bg-tertiary lg:w-[60%] p-6 rounded-lg shadow-lg" ref={popupRef}>
        <div className="flex items-center justify-between">
          <button onClick={onClose} className=" text-lg text-primary1">
            <FaArrowLeft />
          </button>
          <h2 className=" text-3xl font-normal font-outfit text-primary1">Track Order</h2>
          <div></div>
        </div>
        <hr className="my-4" />

        {!orderStatus ? (
          <div>
            <div className="flex gap-4">
              <input
                type="text"
                placeholder="Enter Order ID"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                className="w-[50%] border p-2 rounded text-primary1"
              />
              <button
                onClick={handleSubmit}
                className="w-[50%] bg-hcolor text-tertiary px-4 py-2 rounded"
              >
                Submit
              </button>
            </div>
            <hr className="my-4" />
            <div className="text-center">
              <img src={icons.trackOrderInitial} alt="No Orders" className="mx-auto" />
              <p className="mt-2 text-hcolor">Keep Track of Your Order</p>
            </div>
          </div>
        ) : (
          <div>
            <div className="text-center">
              <h3 className="text-2xl font-light font-outfit text-primary1">Hi {user?.first_name},</h3>
              <p className="text-hcolor font-poppins text-light text-base">
                Tell us your Email ID for sending you your order details.
              </p>
            </div>
            <hr className="my-4" />
            <div className="flex flex-col md:flex-row items-center">
              {/* Order Status Column */}
              <div className="w-full md:w-1/2 flex flex-col items-center">
                <div className="relative h-60 flex flex-col justify-between">
                  {/* Progress Bar */}
                  <motion.div
                    initial={{ height: "0%" }}
                    animate={{ height: progressHeight }}
                    className="absolute left-2 top-0 w-1 bg-hcolor transition-all duration-500"
                  />

                  {/* Order Status Steps */}
                  {orderSteps.map((status, index) => (
                    <div key={index} className="relative flex items-center gap-4">
                      {/* Circle Indicator */}
                      <span
                        className={`w-5 h-5 rounded-full transition-all duration-500 ${
                          index <= currentStepIndex ? "bg-hcolor" : "bg-secondary"
                        }`}
                      ></span>
                      {/* Status Text */}
                      <div>
                        <h4 className="font-normal font-outfit text-lg">Order {status}</h4>
                        <p className="text-sm font-poppins font-light text-hcolor">
                        {status === "PLACED"
  ? "Your order has been placed."
  : status === "SHIPPED"
  ? "Your order is on the way."
  : status === "DELIVERED"
  ? "Your order has been delivered."
  : "Unknown status"} 

                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* Image Column */}
              <div className="w-full md:w-1/2 flex justify-center mt-4 md:mt-0">
                <img src={icons.trackOrderSecond} alt="Order Tracking" className="w-40 md:w-72" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackOrderPopup;













//   import { useState ,useEffect} from "react";
//   import { useParams } from "react-router-dom";
//   import { motion } from "framer-motion";
//   import { useSelector } from "react-redux";
//   import { FaArrowLeft } from "react-icons/fa";
//   import icons from "../../../icons.config";
//   import { fetchOrderDetailsByIdAPI } from "../../../Providers/ordersProvider";
//   import { getUserProfileAPI } from "../../../Providers/profileProvider";

//   const TrackOrderPopup = ({ onClose }) => {
   
//     const { orderId: paramOrderId } = useParams(); // Get orderId from URL params
//   const [orderId, setOrderId] = useState(paramOrderId || ""); // Use state for updating orderId
//     const [orderStatus, setOrderStatus] = useState(null);
//     const [order, setOrder] = useState(null);
//       const [user, setUser] = useState(null);
    

//  // Get authentication details
//  const authToken = useSelector((state) => state.auth.authToken);
//  const user_id = useSelector((state) => state.auth.user?.id) || localStorage.getItem("user_id");
//     // Handle form submission to fetch the order status from API
//     const handleSubmit = async () => {
//       try {
//         localStorage.setItem("authToken", authToken);
//         localStorage.setItem("user_id", user_id);
        
//         console.log("Submitting orderId:", orderId);
//         const sanitizedOrderId = orderId.trim().toUpperCase();
//         const response = await fetchOrderDetailsByIdAPI(sanitizedOrderId, authToken, user_id);
        
//         if (response && response.success && response.items.length > 0) {
//           console.log("Order found:", response.items[0]);
//           setOrder(response.items[0]);
//           setOrderStatus(response.items[0].status);
//         } else {
//           console.log("No order found with ID:", sanitizedOrderId);
//           setOrderStatus(null);
//         }
//       } catch (error) {
//         console.error("Error fetching order details:", error);
//         setOrderStatus(null);
//       }
//     };
//      const [error, setError] = useState(null); // ✅ Fix: Added setError state
//       useEffect(() => {
//         const fetchUserProfile = async () => {
//           try {
//             const response = await getUserProfileAPI();
//             if (response?.data) {
//               setUser(response.data);  // ✅ Ensure correct data assignment
//             } else {
//               setError(response.error || "Unexpected response format");
//               console.error("Error fetching user profile:", response);
//             }
//           } catch (error) {
//             setError("Failed to fetch user profile");
//             console.error("Error fetching user profile:", error);
//           }
//         };
      
//         fetchUserProfile();
//       }, []);

//     return (
//       <div className="fixed inset-0 flex items-center justify-center z-30 top-16 md:top-0 lg:top-24">
//         <div className="bg-tertiary lg:w-[60%] p-6 rounded-lg shadow-lg">
//           <div className="flex items-center justify-between">
//             <button onClick={onClose} className=" text-lg">
//               <FaArrowLeft />
//             </button>
//             <h2 className=" text-3xl font-normal font-outfit text-primary1">Track Order</h2>
//             <div></div>
//           </div>
//           <hr className="my-4" />

//           {!orderStatus ? (
//             <div>
//               <div className="flex gap-4">
//                 <input
//                   type="text"
//                   placeholder="Enter Order ID"
//                   value={orderId}
//                   onChange={(e) => setOrderId(e.target.value)}
//                   className="w-[50%] border p-2 rounded"
//                 />
//                 <button
//                   onClick={handleSubmit}
//                   className="w-[50%] bg-hcolor text-tertiary px-4 py-2 rounded"
//                 >
//                   Submit
//                 </button>
//               </div>
//               <hr className="my-4" />
//               <div className="text-center">
//                 <img
//                   src={icons.trackOrderInitial}
//                   alt="No Orders"
//                   className="mx-auto"
//                 />
//                 <p className="mt-2 text-hcolor">Keep Track of Your Order</p>
//               </div>
//             </div>
//           ) : (
//             <div>
//               <div className="text-center">
//                 <h3 className="text-2xl font-light font-outfit text-primary1">Hi {user?.first_name},</h3>
//                 <p className="text-hcolor font-poppins text-light text-base">
//                   Tell us your Email ID for sending you your order details.
//                 </p>
//               </div>
//               <hr className="my-4" />
//               <div className="flex flex-col md:flex-row items-center">
//                 <div className="w-full md:w-1/2 flex flex-col items-center">
//                   <div className="relative border-secondary h-60 flex flex-col justify-between ">
//                     <motion.div
//                       initial={{ height: "0%" }}
//                       animate={{
//                         height:
//                           orderStatus === "Placed"
//                             ? "33%"
//                             : orderStatus === "Shipped"
//                             ? "66%"
//                             : "100%",
//                       }}
//                       className={`absolute left-0 w-1 ${
//                         orderStatus === "Placed" ||
//                         orderStatus === "Shipped" ||
//                         orderStatus === "Delivered"
//                           ? "bg-hcolor"
//                           : "bg-secondary"
//                       }`}
//                     />

//                     <div className="relative">
//                       <span
//                         className={`absolute -left-2 -top-1 w-5 h-5 ${
//                           orderStatus === "Placed" ||
//                           orderStatus === "Shipped" ||
//                           orderStatus === "Delivered"
//                             ? "bg-hcolor"
//                             : "bg-secondary"
//                         } rounded-full`}
//                       ></span>
//                       <h4 className="ml-6 font-normal font-oufit text-lg">Order Placed</h4>
//                       <p className="ml-6 text-sm font-poppins font-light text-hcolor">
//                         Your order has been placed.
//                       </p>
//                     </div>

//                     <div className="relative">
//                       <span
//                         className={`absolute -left-2 -top-1 w-5 h-5 ${
//                           orderStatus === "Shipped" || orderStatus === "Delivered"
//                             ? "bg-hcolor"
//                             : "bg-secondary"
//                         } rounded-full`}
//                       ></span>
//                       <h4 className="ml-6 font-normal font-oufit text-lg">Order Shipped</h4>
//                       <p className="ml-6 text-sm font-poppins font-light text-hcolor">
//                         Your order is on the way.
//                       </p>
//                     </div>

//                     <div className="relative">
//                       <span
//                         className={`absolute -left-2 -top-1 w-5 h-5 ${
//                           orderStatus === "Delivered"
//                             ? "bg-hcolor"
//                             : "bg-secondary"
//                         } rounded-full`}
//                       ></span>
//                       <h4 className="ml-6 font-normal font-oufit text-lg">Order Delivered</h4>
//                       <p className="ml-6 text-sm font-poppins font-light text-hcolor">
//                         Your order has been delivered.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="w-full md:w-1/2 flex justify-center mt-4 md:mt-0">
//                   <img
//                     src={icons.trackOrderSecond}
//                     alt="Order Tracking"
//                     className="w-40 md:w-72"
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   export default TrackOrderPopup;
